import * as Yup from 'yup';

export default function LoginFormValidation(t) {
  return Yup.object().shape({
    username: Yup.string().email(t('login.validations.email')).required(t('login.validations.username')),
    password: Yup.string().required(t('login.validations.password')),
  });
}
